import { Component, ViewChild } from '@angular/core';
//import { Nav, Platform, Config, AlertController, IonicApp } from 'ionic-angular';
import { Nav, Platform, Config, AlertController, IonicApp } from 'ionic-angular';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';



// Providers
import { GlobalVars } from '../providers/global-vars/globalVars';
import { ApiServiceProvider } from '../providers/api-service/api-service';
import { CommonProvider } from '../providers/common/common';



import moment from 'moment';

declare var window: any;
declare var navigator: any;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: any;

  rootPage: any = "LoginCongresoPage";
  private deferredInstallPrompt: any = null;
  private hasShownInstallPrompt: boolean = false;

  constructor(
    public platform: Platform,
    public globalVars : GlobalVars,
    public config: Config,
    private alertCtrl: AlertController,
    public http: Http,
    public storage: Storage,
    public apiService: ApiServiceProvider,
    public common: CommonProvider,
    private ionicApp: IonicApp,
 
  ) {
    this.initializeApp();

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.initializePwaInstallFlow();

      // Comprobamos en el inicio de sesión si teníamos datos del usuario guardados y los metemos en las globalvars
      this.storage.get("loggedCongreso").then(result => {
        let storedLogged = (result? result: "");
        if(storedLogged === true)  {          
          this.storage.get("userCongreso").then(result2 => {
            let storedUser = (result2? result2 : null);
            //console.log(storedUser);
            if (storedUser!=null){
              console.log("STOREDUSER");
              this.globalVars.setLoggedCongreso(true);
              this.globalVars.setUserCongreso(result2);
              this.globalVars.setNombreCongreso(result2['nombre']);
              this.globalVars.setApellidosCongreso(result2['apellidos']);
              this.globalVars.setTokenCongreso(result2['token']);
              this.globalVars.setIdEvento(result2['idevento']);
              //this.nav.setRoot("CongresoPage");
              //console.log(this.globalVars.getUserCongreso());
            } else {
              this.globalVars.logoutCongreso();
            }
            
          });
        } else {
          //console.log("usuario no logueado");
        }
      });
      
    });

    // Impedir que se pueda salir accidentalmente de la app con el botón Back físico (dispositivos Android)
    this.platform.registerBackButtonAction(() => {
      let activeModal = this.ionicApp._modalPortal.getActive(); //  IonicApp._appRoot._getPortal();
      if(activeModal) { // Si hay modal activo, cerrar modal en lugar de cambiar de página
        activeModal.dismiss();
      } else {
        if(this.nav.getActive().name != 'HomePage') {
          if (this.nav.canGoBack()) {
            this.nav.pop();
          } else {
            this.openHome();
          }
        }
      }
    });

    this.config.set('ios', 'backButtonText', ''); // Eliminar texto 'Back' del botón atrás

    moment.locale("es");
  }

  private initializePwaInstallFlow() {
    if (this.platform.is('cordova') || this.isRunningStandalone()) {
      return;
    }

    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();
      this.deferredInstallPrompt = event;
      this.presentAndroidInstallPrompt();
    });

    if (this.isIosInstallable()) {
      this.presentIosInstallInstructions();
      return;
    }

    if (this.isAndroidBrowser()) {
      setTimeout(() => {
        if (!this.deferredInstallPrompt) {
          this.presentAndroidInstallPromptFallback();
        }
      }, 4000);
    }
  }

  private isRunningStandalone(): boolean {
    return (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      navigator.standalone === true
    );
  }

  private isIosInstallable(): boolean {
    return this.platform.is('ios') && this.isSafariBrowser();
  }

  private isAndroidBrowser(): boolean {
    return this.platform.is('android') && !this.platform.is('cordova');
  }

  private isSafariBrowser(): boolean {
    let userAgent = window.navigator.userAgent || '';
    return /safari/i.test(userAgent) && !/crios|fxios|edgios|opr\//i.test(userAgent);
  }

  private getInstallPromptStorageKey(platformName: string): string {
    return 'pwa-install-prompt-dismissed-' + platformName + '-' + this.globalVars.getAppVersion();
  }

  private hasDismissedInstallPrompt(platformName: string): Promise<boolean> {
    return this.storage.get(this.getInstallPromptStorageKey(platformName)).then((dismissed) => dismissed === true);
  }

  private markInstallPromptDismissed(platformName: string): Promise<any> {
    return this.storage.set(this.getInstallPromptStorageKey(platformName), true);
  }

  private presentAndroidInstallPrompt() {
    if (this.hasShownInstallPrompt || !this.deferredInstallPrompt) {
      return;
    }

    this.hasDismissedInstallPrompt('android').then((dismissed) => {
      if (dismissed || this.hasShownInstallPrompt || !this.deferredInstallPrompt) {
        return;
      }

      this.hasShownInstallPrompt = true;

      let alert = this.alertCtrl.create({
        title: 'Instalar app en Android',
        subTitle: 'Version ' + this.globalVars.getAppVersion(),
        message: 'Aunque puedes navegar por la app desde tu navegador, también puedes instalar USO Eventos en tu dispositivo para abrirla como una app y acceder mas rapido.<br><br>Pulsa "Instalar" para continuar con el aviso de Android.',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ahora no',
            handler: () => {
              this.markInstallPromptDismissed('android');
              this.hasShownInstallPrompt = false;
            }
          },
          {
            text: 'Instalar',
            handler: () => {
              let deferredPrompt = this.deferredInstallPrompt;
              this.deferredInstallPrompt = null;
              this.hasShownInstallPrompt = false;

              if (!deferredPrompt) {
                return;
              }

              deferredPrompt.prompt();
              deferredPrompt.userChoice.then((choiceResult: any) => {
                if (!choiceResult || choiceResult.outcome !== 'accepted') {
                  this.markInstallPromptDismissed('android');
                }
              }).catch(() => {
                this.markInstallPromptDismissed('android');
              });
            }
          }
        ]
      });

      alert.present();
    });
  }

  private presentAndroidInstallPromptFallback() {
    if (this.hasShownInstallPrompt) {
      return;
    }

    this.hasDismissedInstallPrompt('android').then((dismissed) => {
      if (dismissed || this.hasShownInstallPrompt || this.isRunningStandalone()) {
        return;
      }

      this.hasShownInstallPrompt = true;

      let alert = this.alertCtrl.create({
        title: 'Instalar app en Android',
        subTitle: 'Version ' + this.globalVars.getAppVersion(),
        message: 'Aunque puedes navegar por la app desde tu navegador, también puedes instalar USO Eventos en tu dispositivo para abrirla como una app y acceder mas rapido.<br><br>Si no ves el aviso automatico de instalacion, abre el menu del navegador y pulsa "Instalar app" o "Anadir a pantalla de inicio".',
        buttons: [
          {
            text: 'Entendido',
            handler: () => {
              this.markInstallPromptDismissed('android');
              this.hasShownInstallPrompt = false;
            }
          }
        ]
      });

      alert.present();
    });
  }

  private presentIosInstallInstructions() {
    if (this.hasShownInstallPrompt) {
      return;
    }

    this.hasDismissedInstallPrompt('ios').then((dismissed) => {
      if (dismissed || this.hasShownInstallPrompt || this.isRunningStandalone()) {
        return;
      }

      this.hasShownInstallPrompt = true;

      let alert = this.alertCtrl.create({
        title: 'Instalar app en iPhone o iPad',
        subTitle: 'Version ' + this.globalVars.getAppVersion(),
        message: 'Aunque puedes navegar por la app desde tu navegador, también puedes instalar USO Eventos en tu dispositivo para abrirla como una app y acceder mas rapido.<br><br>Debes hacer lo siguiente:<br><br>1. Pulsa el boton Compartir de Safari.<br>2. Selecciona "Anadir a pantalla de inicio".<br>3. Confirma con "Anadir" para instalar USO Eventos como app.',
        buttons: [
          {
            text: 'No volver a mostrar',
            handler: () => {
              this.markInstallPromptDismissed('ios');
              this.hasShownInstallPrompt = false;
            }
          },
          {
            text: 'Cerrar',
            handler: () => {
              this.hasShownInstallPrompt = false;
            }
          }
        ]
      });

      alert.present();
    });
  }

    openPage(page: any) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //this.nav.setRoot(page.component);
    this.nav.setRoot(page.component, page.params);
  }

  /*goToAfiliate(){    
    this.nav.setRoot("AfiliatePage");
  }*/

  goToCongreso(){    
    this.nav.setRoot("CongresoPage");
  }

  openHome() {
    this.nav.setRoot("HomePage");
  }

  openLogin(){
    //this.nav.push(LoginPage);
     this.nav.setRoot("LoginPage");
  }
  

  /* Funciones notificaciones push */
  
  logError(error: any) {
    //console.log('Error: ' + error);
  };

  openUrl(url:string) {
    this.globalVars.openUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts